import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "./components/ui";
import Router from "./routes/Router";
import { FloatingSocials, ScrollToTop, CookieConsent, WhatsAppFloatingButton } from "@/components";


function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <FloatingSocials />
      <WhatsAppFloatingButton />
      <Router />
      <Toaster position="top-right" />
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
